let Breakpoints = {
  computed: {
    // breakpoints only

    screenOnly() {
      return this.$vuetify.breakpoint.xl;
    },

    laptopOnly() {
      return this.$vuetify.breakpoint.lg;
    },

    tabletOnly() {
      return this.$vuetify.breakpoint.md;
    },

    phabletOnly() {
      return this.$vuetify.breakpoint.sm;
    },

    phoneOnly() {
      return this.$vuetify.breakpoint.xs;
    },

    // breakpoints and down

    screen() {
      return this.$vuetify.breakpoint.xl || this.laptop;
    },

    laptop() {
      return this.$vuetify.breakpoint.lg || this.tablet;
    },

    tablet() {
      return this.$vuetify.breakpoint.md || this.phablet;
    },

    phablet() {
      return this.$vuetify.breakpoint.sm || this.phone;
    },

    phone() {
      return this.$vuetify.breakpoint.xs;
    },
  },
};

export default Breakpoints;
